// 公共的侧边栏栏
import Layout from "@/pages/layout/layout";
import Loginh5 from "../pages/h5/loginh5.vue";

// 不作为main组件子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/login",
  name: "login",
  meta: {
    title: "Login - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/login"),
};
export const centerRouter = {
  path: "/center",
  name: "center",
  meta: {
    title: "center - 登录",
    keepAlive: false,
  },
  component: () => import("@/pages/login/center"),
};
// 错误页面
export const errorRouter = {
  path: "/error/:code",
  name: "error",
  meta: {
    title: "error",
  },
  component: () => import("@/pages/error/index"),
};
//用户手机登录后台OA提示页面
export const loginh5Router = {
  path: "/loginh5",
  name: "loginh5",
  meta: {
    title: "loginh5",
    keepAlive: false,
  },
  component: () => import("@/pages/h5/loginh5"),

};
// 作为main组件子页面展示  但不在左侧菜单显示的路由卸载otherRoter里
export const otherRouter = {
  path: '',
  name: 'otherRouter',
  redirect: '/home',
  meta: {
    requireAuth: true,
    title: '首页',
  },
  component: Layout,
  children: [
    {path:'personalDrive',name:'personalDrive',meta:{title:'文件管理',keepAlive:false},component:()=>import('@/pages/personalDrive/index.vue')},
    {
      path: 'chatAudit', name: 'chatAudit', meta: { title: '查看所有聊天记录', keepAlive: false },
      component: () => import('@/pages/chatAudit/index.vue'),
    },
    {
      path: 'pushSettings', name: 'pushSettings', meta: { title: '消息推送设置', keepAlive: false },
      component: () => import('@/pages/pushSettings/index.vue'),
    },
    {
      path: 'fileCenter', name: 'fileCenter', meta: { title: '聊天文件', keepAlive: false },
      component: () => import('@/pages/fileCenter/index.vue'),
    },
    {
      path: 'home',
      name: 'home',
      meta: {
        title: '工作台',
        keepAlive: true,
      },
      component: () => import('@/pages/home/welcome'),
    },
    {
      path: 'info',
      name: 'info',
      meta: {
        title: '个人信息',
        keepAlive: true,
      },
      component: () => import('@/pages/info/info'),
    },
    {
      path: 'staffManagement/roster',
      name: 'roster',
      meta: {
        title: '花名册',
        keepAlive: true,
      },
      component: () => import('@/pages/staffManagement/roster/roster'),
    },
    {
      path: 'staffManagement/addSatff',
      name: 'addSatff',
      meta: {
        title: '新增员工',
        keepAlive: true,
      },
      component: () => import('@/pages/staffManagement/roster/addStaff'),
    },
    {
      path: 'staffManagement/editSatff',
      name: 'editSatff',
      meta: {
        title: '编辑员工',
        keepAlive: true,
      },
      component: () => import('@/pages/staffManagement/roster/addStaff'),
    },
    {
      path: 'staffManagement/employment',
      name: 'employment',
      meta: {
        title: '任职管理',
        keepAlive: true,
      },
      component: () => import('@/pages/staffManagement/employment/employment'),
    },
    {
      path: 'hireManagement/application',
      name: 'application',
      meta: {
        title: '应聘信息',
        keepAlive: true,
      },
      component: () => import('@/pages/hireManagement/application/application'),
    },
    {
      path: 'hireManagement/addApplication',
      name: 'addApplication',
      meta: {
        title: '新增-应聘信息',
        keepAlive: true,
      },
      component: () => import('@/pages/hireManagement/application/addApplication'),
    },
    {
      path: 'hireManagement/editApplication',
      name: 'editApplication',
      meta: {
        title: '查看-应聘信息',
        keepAlive: true,
      },
      component: () => import('@/pages/hireManagement/application/addApplication'),
    },
    {
      path: 'officeApproval/list',
      name: 'sendApprovalList',
      meta: {
        title: '发起审批',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/sendApproval/list'),
    },
    {
      path: 'officeApproval/sendApproval',
      name: 'sendApproval',
      meta: {
        title: '发起审批-详情',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/sendApproval/sendApproval'),
    },
    {
      path: 'officeApproval/approvalMyList',
      name: 'approvalMyList',
      meta: {
        title: '我发起的',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/myList.vue'),
    },
    {
      path: 'officeApproval/approvalMyDetail',
      name: 'approvalMyDetail',
      meta: {
        title: '我发起的-详情',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/myDetail.vue'),
    },
    {
      path: 'officeApproval/approvalManageList',
      name: 'approvalManageList',
      meta: {
        title: '我处理的',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/manageList'),
    },
    {
      path: 'officeApproval/approvalManageDetail',
      name: 'approvalManageDetail',
      meta: {
        title: '我处理的-详情',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/manageDetail.vue'),
    },
    {
      path: 'officeApproval/approvalCCList',
      name: 'approvalCCList',
      meta: {
        title: '抄送给我的',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/ccList'),
    },
    {
      path: 'officeApproval/approvalCCDetail',
      name: 'approvalCCDetail',
      meta: {
        title: '抄送给我的-详情',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/ccDetail'),
    },
    {
      path: 'officeApproval/approvalAllList',
      name: 'approvalAllList',
      meta: {
        title: '全部审批数据',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/allList'),
    },

    {
      path: 'officeApproval/approvalAllDetail',
      name: 'approvalAllDetail',
      meta: {
        title: '全部审批数据-详情',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalList/allDetail'),
    },
    {
      path: 'officeApproval/approvalManagement',
      name: 'approvalManagement',
      meta: {
        title: '审批单管理',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalManagement/approvalManagement'),
    },
    {
      path: 'officeApproval/approvalManagement/addApproval',
      name: 'addApproval',
      meta: {
        title: '新增-审批单',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalManagement/addApproval'),
    },
    {
      path: 'officeApproval/approvalManagement/editApproval',
      name: 'editApproval',
      meta: {
        title: '查看编辑-审批单',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/approvalManagement/addApproval'),
    },
    {
      path: 'officeApproval/processManagement',
      name: 'processManagement',
      meta: {
        title: '审批流管理',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/processManagement/processManagement'),
    },
    {
      path: 'officeApproval/processManagement/editProcess',
      name: 'editProcess',
      meta: {
        title: '查看编辑-审批流',
        keepAlive: true,
      },
      component: () => import('@/pages/officeApproval/processManagement/editProcess'),
    },
    {
      path: 'attendanceManagement/list',
      name: 'attendanceManagementList',
      meta: {
        title: '班次管理',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/list/list'),
    },
    {
      path: 'attendanceManagement/list/add',
      name: 'attendanceManagementListAdd',
      meta: {
        title: '新增班次',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/list/form'),
    },
    {
      path: 'attendanceManagement/list/edit',
      name: 'attendanceManagementListEdit',
      meta: {
        title: '编辑班次',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/list/form'),
    },
    {
      path: 'attendanceManagement/team',
      name: 'attendanceManagementTeam',
      meta: {
        title: '考勤组管理',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/team/team'),
    },
    {
      path: 'attendanceManagement/team/add',
      name: 'attendanceManagementTeamAdd',
      meta: {
        title: '新增考勤组',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/team/form'),
    },
    {
      path: 'attendanceManagement/team/edit',
      name: 'attendanceManagementTeamEdit',
      meta: {
        title: '编辑考勤组',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/team/form'),
    },
    {
      path: 'attendanceManagement/schedule',
      name: 'attendanceManagementSchedule',
      meta: {
        title: '排班管理',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/schedule/schedule'),
    },
    {
      path: 'attendanceManagement/schedule/detail',
      name: 'attendanceManagementScheduleDetail',
      meta: {
        title: '排班详情',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/schedule/detail'),
    },
    {
      path: 'attendanceManagement/stat',
      name: 'attendanceManagementStat',
      meta: {
        title: '考勤统计',
        keepAlive: true,
      },
      component: () => import('@/pages/attendanceManagement/stat/stat'),
    },
    {
      path: 'basic/menu',
      name: 'menu',
      meta: {
        title: '菜单管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/menu'),
    },
    {
      path: 'basic/menuBtn',
      name: 'menuBtn',
      meta: {
        title: '菜单按钮',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/menuBtn'),
    },
    {
      path: 'basic/department',
      name: 'department',
      meta: {
        title: '部门管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/department'),
    },
    {
      path: 'basic/position',
      name: 'position',
      meta: {
        title: '职位管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/position'),
    },
    {
      path: 'basic/role',
      name: 'role',
      meta: {
        title: '角色管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/role'),
    },
    {
      path: 'basic/jurisdiction',
      name: 'jurisdiction',
      meta: {
        title: '权限管理',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/jurisdiction'),
    },
        {
      path: 'basic/update',
      name: 'update',
      meta: {
        title: 'APP更新',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/update'),
    },
    {
      path: 'basic/processHandover',
      name: 'processHandover',
      meta: {
        title: '流程交接',
        keepAlive: true,
      },
      component: () => import('@/pages/basic/processHandover'),
    },
    {
      path: 'notice',
      name: 'notice',
      meta: {
        title: '通知公告',
        keepAlive: true
      },
      component: () => import('@/pages/notice/notice')
    },
    {
      path: 'noticeDetail',
      name: 'noticeDetail',
      meta: {
        title: '通知公告详情',
        keepAlive: true
      },
      component: () => import('@/pages/notice/noticeDetail')
    },
    {
      path: 'assetManagement/platformAccount/list',
      name: 'platformAccountList',
      meta: {
        title: '平台账号管理',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/platformAccount/list')
    },
    {
      path: 'assetManagement/platformAccount/add',
      name: 'platformAccountAdd',
      meta: {
        title: '新增平台账号',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/platformAccount/add')
    },
    {
      path: 'assetManagement/platformAccount/detail',
      name: 'platformAccountDetail',
      meta: {
        title: '平台账号详情',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/platformAccount/detail')
    },
    {
      path: 'assetManagement/workPhone/list',
      name: 'workPhoneList',
      meta: {
        title: '工作手机号管理',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workPhone/list')
    },
    {
      path: 'assetManagement/workPhone/detail',
      name: 'workPhoneDetail',
      meta: {
        title: '工作手机号详情',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workPhone/detail')
    },
    {
      path: 'assetManagement/workPhone/add',
      name: 'workPhoneAdd',
      meta: {
        title: '新增工作手机号',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workPhone/add')
    },
    {
      path: 'assetManagement/workQQ/list',
      name: 'workQQList',
      meta: {
        title: '工作QQ号管理',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workQQ/list')
    },
    {
      path: 'assetManagement/workQQ/add',
      name: 'workQQAdd',
      meta: {
        title: '新增工作QQ号',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workQQ/add')
    },
    {
      path: 'assetManagement/workQQ/detail',
      name: 'workQQDetail',
      meta: {
        title: '工作QQ号详情',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workQQ/detail')
    },
    {
      path: 'assetManagement/workWechat/list',
      name: 'workWechatList',
      meta: {
        title: '工作微信号管理',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workWechat/list')
    },
    {
      path: 'assetManagement/workWechat/add',
      name: 'workWechatAdd',
      meta: {
        title: '新增工作微信号',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workWechat/add')
    },
    {
      path: 'assetManagement/workWechat/detail',
      name: 'workWechatDetail',
      meta: {
        title: '工作微信号详情',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workWechat/detail')
    },
    {
      path: 'assetManagement/workEmail/list',
      name: 'workEmailList',
      meta: {
        title: '工作邮箱管理',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workEmail/list')
    },
    {
      path: 'assetManagement/workEmail/add',
      name: 'workEmailAdd',
      meta: {
        title: '新增工作邮箱',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workEmail/add')
    },
    {
      path: 'assetManagement/workEmail/detail',
      name: 'workEmailDetail',
      meta: {
        title: '工作邮箱详情',
        keepAlive: true
      },
      component: () => import('@/pages/assetManagement/workEmail/detail')
    },
    {
      path: 'announcement/list',
      name: 'announcementList',
      meta: {
        title: '公告管理',
        keepAlive: true
      },
      component: () => import('@/pages/announcement/list')
    },
    {
      path: 'workbenchContent',
      name: 'workbenchContent',
      meta: { title: '内容管理', keepAlive: false },
      component: () => import('@/pages/announcement/workbenchContent')
    },
    {
      path: 'announcement/add',
      name: 'announcementAdd',
      meta: {
        title: '新增公告',
        keepAlive: true
      },
      component: () => import('@/pages/announcement/add')
    },
    {
      path: 'announcement/detail',
      name: 'announcementDetail',
      meta: {
        title: '公告详情',
        keepAlive: true
      },
      component: () => import('@/pages/announcement/detail')
    },
    {
      path: 'announcement/lookDetail',
      name: 'announcementLookDetail',
      meta: {
        title: '公告详情',
        keepAlive: true
      },
      component: () => import('@/pages/announcement/lookDetail')
    },
    // {
    //   path: 'loginh5',
    //   name: 'loginh5',
    //   meta: {
    //     title: '登录提示',
    //     keepAlive: true
    //   },
    //   component: () => import('@/pages/h5/loginh5')
    // },
  ]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "",
    name: "toname",
    meta: {
      requireAuth: true,
    },
    component: Layout,
    children: [
      {
        path: "/main_view",
        name: "main_view",
        title: "首页",
        component: () => import("@/pages/main_view/main_view"),
      },
    ],
  },
];

export const routers = [loginRouter, centerRouter, loginh5Router,errorRouter, otherRouter, ...appRouter];
